<ng-template #stepTemplate>
  <li
    class="m-step-indicator__step tw-flex tw-flex-col tw-items-center"
    [class.-active]="active"
    [style.min-width]="customWidth"
  >
    <div class="m-step-indicator__node tw-self-center" [attr.test-id]="testId">
      <ng-container *ngIf="!iconIndicator">
        {{ indicator }}
      </ng-container>
      <ng-container *ngIf="iconIndicator">
        <bosch-ui-icon [name]="iconIndicator"></bosch-ui-icon>
      </ng-container>
    </div>
    <span class="m-step-indicator__label tw-self-center">
      <ng-container *ngIf="label">
        {{ label }}
      </ng-container>
      <ng-container *ngIf="!label">
        <ng-content select="[step-label]"></ng-content>
      </ng-container>
    </span>
    <span>
      <ng-content select="[step-content]"></ng-content>
    </span>
  </li>
</ng-template>
